import React from 'react';
import styled from 'styled-components';
import {SwitchButton as SuperSwitchButton} from '@etiquette-ui/selectors';

import { useTemperature } from '@appsinti/temperature-provider';
import Temperature from '@appsinti/common-utils/interfaces/weather/Temperature';

import { PRIMARY } from '@etiquette-ui/colors';

const CustomSuperSwitchButton = styled(SuperSwitchButton)<{active: boolean, label: string}>`
  width: 100%;
  height: 25px;
  margin-left: 0px;

  background-color: ${({active}) => active ? "#FFB100" : PRIMARY };
  transition-duration: .3s;
  transition-property: background-color;

  &::before, &::after {
    position: absolute;

    top: 5px;
    z-index: 2;

    font-size: 12px;
    font-weight: 600;
    font-family: 'Montserrat';

    transition-duration: .5s;
    transition-property: color;
  }

  &::before {
    content: '°F';
    left: 5px;
    color: ${({label}) => label === 'F' ? PRIMARY : 'white'};
  }

   &::after {
    content: '°C';
    right: 8px;
    color: ${({label}) => label === 'C' ? '#FFB100' : 'white'};
  }

  div {
    height: 23px;
    width: 23px;
    margin-top: -2px;
    transform: translate( ${({active}) => active ? 25 : 2  }px, 3px);
    transition-duration: .3s;
    transition-property: transform;
    border: transparent!important;
    outline: solid 1px ${({label}) => label === 'C' ? '#FFB100' : PRIMARY};
    transition-duration: .3s;

    &:hover{
      outline: solid 1px ${({label}) => label === 'C' ? '#FFB100' : PRIMARY};
    }
  }

`; 

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  z-index: 2;
`;


const SwitchButton: React.FC = () => {

  const { selectedTemperatureUnit, setSelectedTemperatureUnit } = useTemperature();

  const getIsActive: (unit: keyof Temperature) => boolean = (unit) => {
    return unit === 'C' ? true : false;
  }

  const changeUnit: ()=>void = () => {
    setSelectedTemperatureUnit( selectedTemperatureUnit === 'C' ? 'F' : 'C' );
  }

  return (
    <Container onClick={changeUnit}>
      <CustomSuperSwitchButton label={selectedTemperatureUnit} active={ getIsActive(selectedTemperatureUnit) }/>
    </Container>
    
  )
}

export default SwitchButton;
